<template>
	<NuxtUiModal :title="title" :description="description" :close="{ onClick: () => close(false) }" class="min-w-[calc(100vw-var(--spacing)*8)] lg:min-w-lg" @after:leave="close(undefined)">
		<template #footer>
			<div class="flex gap-4">
				<NuxtUiButton variant="solid" :color="color" :label="buttonConfirmText" @click="close(true)" />
				<NuxtUiButton variant="outline" color="neutral" :label="buttonCancelText" @click="close(false)" />
			</div>
		</template>
	</NuxtUiModal>
</template>

<script setup lang="ts">


defineProps({
	title: {
		type: String,
		default: ''	
	},
	description: {
		type: String,
		default: ''
	},
	buttonConfirmText: {
        type: String,
        default: 'Подтвердить'
    },
    buttonCancelText: {
        type: String,
        default: 'Отменить'
    },
	color: {
		type: String as PropType<"error" | "success" | "warning" | "info" | "neutral" | "primary">, 
		default: 'primary'
	}
})

const emits = defineEmits(['cancel', 'confirm', 'dismiss'])

const close = (e: boolean | undefined) => {
	if (e == undefined) return emits('dismiss')
	emits(e ? 'confirm' : 'cancel')
}
</script>